import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Upload, Modal   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			value: '',
			 previewVisible: false,
			previewImage: '',
			previewTitle: '',
			fileList: [],
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
	}
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
	
	handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

		this.setState({
		  previewImage: file.url || file.preview,
		  previewVisible: true,
		  previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
		});
	};

  handleChange = ({ fileList }) => this.setState({ fileList });

	
	render()

	{
	
	const { size } = this.state;
	 const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <div className="ant-upload-text">Upload</div>
      </div>
    );
		return (
			<div>
			
			<div id="main" class="bg-off">
         <div class="row">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="container">
                  <div class="row">
				  <div class="col s12 m10 col-md-offset-1 header-title mt-20 mh-40">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Photos</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Photos
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            
            <div class="container ">
			   <div class="col s12 m10 col-md-offset-1 mb-20 card-content">
                  <section class="invoice-list-wrapper section food">
					<div class="children">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Children" classname="as" key="1">
						  <p>No child is selected.</p>
						  <Button className="snd-btn" >Select Child</Button>
						</Panel>
					  </Collapse>
					</div> 
					
					
					<div class="children bg-blue">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="Images"  key="1">
							
								  <div className="clearfix">
									<Upload
									  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
									  listType="picture-card"
									  fileList={fileList}
									  onPreview={this.handlePreview}
									  onChange={this.handleChange}
									>
									  {fileList.length >= 8 ? null : uploadButton}
									</Upload>
									<Modal
									  visible={previewVisible}
									  title={previewTitle}
									  footer={null}
									  onCancel={this.handleCancel}
									>
									  <img alt="example" style={{ width: '100%' }} src={previewImage} />
									</Modal>
								  </div>
						</Panel>
					  </Collapse>
					</div>	
					<div class="meal mt-20 mb-20 pb-20 bb">
						<div class="row">
						<div class="col m12">
						 <TextArea
						  placeholder="Enter Details Here !!"
						  autoSize={{ minRows: 2, maxRows: 6 }}
						/>
						</div>
						
						
						</div>
					</div>
					<div class="meal mt-20 mb-20 pb-20 bb center">
						 <Button className="cancel-btn" >Cancle</Button>
						 <Button className="snd-btn" >Send</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
